module.exports = __webpack_public_path__ + "img/yun.953650f4.png";